import React, { useCallback } from 'react';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import { isPAG } from '../../[lang]/mission/[theme]/utils';
const PagImage = dynamic(() => import('./pag'), { ssr: false });

const isPic = (url) => {
  return /\.(png|jpg|jpeg|svg)$/.test(url);
};

export const HexImage = (props) => {
  const { scaleMode, ...restProps } = props;
  if (!props.src) return null;
  const loader = useCallback(({ src, width, quality }) => {
    return `${src}${isPic(src) && src.indexOf('?') < 0 ? '?x-oss-process=image/resize,w_' + width + ',q_' + (quality || 80) : ''}`;
  }, []);
  if (isPAG(props.src)) {
    return <PagImage src={props.src} {...props} />;
  }
  return (
    <Image
      loader={loader}
      alt="image"
      {...restProps}
      width={restProps.width || 750}
      height={restProps.height || 1}
    />
  );
};
